import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { IRequestAccessProps } from '../../types/RequestAccess.types';

interface IRequestAccessLocalState {
  isContinueEnabled: boolean;
}

class RequestAccess extends React.Component<IRequestAccessProps, IRequestAccessLocalState> {
  state = {
    isContinueEnabled: false
  };

  nextStep = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    this.props.nextStep();
  };

  previousStep = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    this.props.previousStep();
  };
  render() {
    return (
      <>
        <br />
        <br />
        <Grid container justify="center">
          <Grid item xs={12} md={6}>
            <Typography align="left">{this.props.languageStrings.requestAccess.helpText}</Typography>
            <br />
            <TextField
              multiline
              rows={6}
              style={{ width: '100%' }}
              variant="outlined"
              required
              label={this.props.languageStrings.requestAccess.textAreaLabel}
              value={this.props.data.requestAccessReason}
              onChange={event => this.props.handleChange('requestAccess', 'requestAccessReason')(event)}
              inputProps={{ 'data-testid': 'requestAccessReason' }}
            />
          </Grid>
        </Grid>
        <div className="Form-actions multiple">
          <Button
            variant="outlined"
            color="primary"
            onClick={e => {
              this.previousStep(e);
            }}
          >
            {this.props.languageStrings.backButtonLabel}
          </Button>
          <Button
            disabled={this.props.data.requestAccessReason.trim().length <= 0}
            variant="contained"
            color="primary"
            onClick={e => {
              this.nextStep(e);
            }}
            data-testid="continue"
          >
            {this.props.languageStrings.continueButtonLabel}
          </Button>
        </div>
      </>
    );
  }
}

export default RequestAccess;
